import { render, staticRenderFns } from "./interation.vue?vue&type=template&id=7971194e&scoped=true"
import script from "./interation.vue?vue&type=script&lang=js"
export * from "./interation.vue?vue&type=script&lang=js"
import style0 from "./interation.vue?vue&type=style&index=0&id=7971194e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7971194e",
  null
  
)

export default component.exports